import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import * as styles from './Label.module.scss';

const cx = classNames.bind(styles);

const Label = ({ text, type, theme, className, position }) => (
  <div
    className={cx(className, `type${type}`, `${position}`, {
      [`theme${theme}`]: theme,
    })}
  >
    {text}
  </div>
);
Label.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(['New', 'Payment']).isRequired,
  theme: PropTypes.oneOf(['Blue', 'Orange', 'Yellow']),
  position: PropTypes.oneOf(['before', 'after']),
};
Label.defaultProps = {
  text: '',
  type: 'New',
  position: 'after',
};

export default Label;
